import React, { useEffect, useRef, useState } from "react"
import { Card, CardBody } from "reactstrap"
import NameAvatar from "components/custom/nameAvatar"
import SyncfusionGrid from "components/custom/Syncfusion/SyncfusionGrid"

const ModelGroupsGrid = ({
  modelGroups,
  props,
  reloadData,
  scenarioTypes,
  editModelGroup,
}) => {
  const handleModelPress = (e, model) => {
    e && e.preventDefault()
    editModelGroup(model)
  }

  const handleAltPress = (e, model) => {
    e && e.preventDefault()
    props.history.push(`/projects/-${model.scenarioGroupID}`)
  }

  const columns = [
    {
      headerText: "Portfolio Type",
      field: "scenarioGroupID",
      width: 150,
      template: data => {
        return (
          <div
            style={{
              margin: 0,
              fontSize: "12px",
              textAlign: "center",
              backgroundColor: "#123456",
              display: "inline-block",
              padding: "4px 10px",
              borderRadius: "15px",
              color: "#FFFFFF",
              lineHeight: "20px",
            }}
          >
            Portfolio Group
          </div>
        )
      },
    },
    {
      headerText: "Portfolio Manager",
      field: "userName",
      width: 200,
      template: data => (
        <NameAvatar
          fullName={data.userName}
          showName={true}
          base64Image={data.photoBase64}
        />
      ),
    },
    {
      headerText: "Portfolio Group",
      field: "scenarioGroupName",
      width: 200,
      template: data => (
        <a href="#" onClick={e => handleModelPress(e, data)}>
          {data.scenarioGroupName}
        </a>
      ),
    },

    {
      headerText: `View`,
      field: "scenarioID",
      width: 150,
      template: data => (
        <a href="#" onClick={e => handleAltPress(e, data)}>
          Projects
        </a>
      ),
    },
    {
      headerText: "Active",
      field: "inactive",
      textAlign: "Center",
      width: 100,
      filter: {
        type: "Excel",
        itemTemplate: data =>
          data.inactive == 0 ? (
            <span style={{ color: "green" }}>Yes</span>
          ) : (
            <span style={{ color: "red" }}>
              <b>No</b>
            </span>
          ),
      },
      template: data => {
        return data.inactive == 0 ? (
          <span style={{ color: "green" }}>Yes</span>
        ) : (
          <span style={{ color: "red" }}>
            <b>No</b>
          </span>
        )
      },
    },
    {
      headerText: "Last modified",
      field: "updateDT",
      width: 100,
      template: data => {
        let date = new Date(data.updateDT)
        return (
          date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear()
        )
      },
    },
  ]

  return (
    <Card>
      <CardBody>
        {modelGroups.length > 0 && (
          <SyncfusionGrid columns={columns} data={modelGroups} />
        )}
      </CardBody>
    </Card>
  )
}

export default ModelGroupsGrid
